export default {"src":"/_next/static/media/info.dc9b8332.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};